import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import type { LoggerTimesFieldsWithDefaults, LoggerTimesSchemaTypes } from "../../types/loggerTimes.d.js";
import type { DtoValidatorTypes } from "../../validatableClass.js";

const SCHEMA_KEY = "LoggerTimes" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerTimes>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerTimes extends SchemaBase<LoggerTimes, LoggerTimesFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public timeRecieved?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public timeTTIReceived?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public timeSent?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public curDeviceTime?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public generatedParsedUplink?: Date;

    /** Gen4 only — not populated in Gen3 (Sprout) paths. */
    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public finishedLoadAll?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public finishedUpdateRecords?: Date;

    /** Gen4 only — not populated in Gen3 (Sprout) paths. */
    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public finishedShouldRespond?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public finishedSendingResponse?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public startedSendingResponse?: Date;

    /** Gen4 only — not populated in Gen3 (Sprout) paths. */
    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public finishedUpdatingDatapoints?: Date;

    @validate({ zodValidator: z.coerce.date().optional(), responseOnly: true })
    @prop({ type: () => Date, required: false })
    public timeGatewayReceivedUplink?: Date;

    static getters = {} as const satisfies Record<string, (self: LoggerTimes) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    static dtoValidators: DtoValidatorTypes<LoggerTimesSchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<LoggerTimes, LoggerTimesFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

LoggerTimes.dtoValidators = getZodSchemaFromClass(LoggerTimes) as unknown as DtoValidatorTypes<LoggerTimesSchemaTypes>;
